module.exports = __webpack_public_path__ + "img/core-values.0438b7cf.jpg";